import { DefaultCheckbox } from '@common/components/default-checkbox';
import WaveSelectField from '@common/components/form/WaveSelectField';
import WaveTextField from '@common/components/form/WaveTextField';
import StyledDivider from '@common/components/misc/StyledDivider';
import SelectFieldOptions from '@common/config/SelectFieldOptions';
import DefaultEmail from '@common/config/Tooltip/DefaultEmail';
import InstituteLogoText from '@common/config/Tooltip/InstituteLogoText';
import SSODomainName from '@common/config/Tooltip/SSODomainName';
import TooltipTitle from '@common/config/Tooltip/TooltipTitle';
import MetadataService from '@common/services/MetadataService';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from 'tss-react/mui';
import InstituteDeactivationSection from './InstituteDeactivationSection';
import { instituteDetailsStyles } from './styles';

class InstituteDetails extends React.Component {
  meta = new MetadataService();

  errorHelpers = (field) => {
    if (this.props.validationErrors.hasOwnProperty(field)) {
      return this.props.validationErrors[field][0];
    }
    return null;
  };

  errorStatus = (field) => {
    return this.props.validationErrors.hasOwnProperty(field);
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let institute = { ...this.props.instituteDetails };
    institute[name] = value;

    this.props.onInstituteChange(institute);
  };

  handleCheckboxChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let institute = { ...this.props.instituteDetails };
    if (target.checked) {
      institute[name].push(value);
    } else {
      const idx = institute[name].indexOf(value);
      if (idx > -1) {
        institute[name].splice(idx, 1);
      }
    }

    this.props.onInstituteChange(institute);
  };

  makeFieldProps = (field) => {
    return {
      error: this.errorStatus(field),
      helperText: this.errorHelpers(field),
      name: field,
      onChange: this.handleInputChange,
      value: this.props.instituteDetails[field]
    };
  };

  render() {
    const { classes, instituteDetails, onInstituteChange, timezoneOptions, user } = this.props;
    const instituteMeta = this.meta.get('institutes');
    const {
      ical_type: { options: icalTypeOptions }
    } = instituteMeta;

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Paper className={classes.instituteDetailsContainer}>
            <form noValidate autoComplete="off">
              <Typography className={classes.sectionHeaders}>
                Institute Branding
              </Typography>
              <Grid container>
                <Grid className={classes.formLeft} size={6}>
                  <WaveTextField
                    label="Institute Name"
                    maxLength={50}
                    {...this.makeFieldProps('name')}
                  />
                </Grid>
                <Grid className={classes.formRight} size={6}>
                  <WaveTextField
                    fileUpload={
                      <InputAdornment position="end">
                        <Button
                          className={classes.logoUpload}
                          color="secondary"
                          component="label"
                          size="small"
                          variant="contained"
                        >
                          <Typography variant="button">Browse</Typography>
                          <input
                            accept=".png"
                            className={classes.hideInput}
                            onChange={(event) => {
                              this.props.onLogoChange(event.target.files[0]);
                              event.target.value = null;
                            }}
                            type="file"
                          />
                        </Button>
                      </InputAdornment>
                    }
                    label="Institute Logo"
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: <InstituteLogoText />,
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    value={instituteDetails.logo_filename}
                  />
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Primary Color"
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: (
                        <Typography className={classes.tooltipText}>
                          {TooltipTitle.primaryColour}
                        </Typography>
                      ),
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    {...this.makeFieldProps('primary_color')}
                  />
                </Grid>
                <Grid size={6} className={classes.formRight}>
                  <WaveTextField
                    label="Primary Color - Light"
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: (
                        <Typography className={classes.tooltipText}>
                          {TooltipTitle.primaryLightColour}
                        </Typography>
                      ),
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    {...this.makeFieldProps('primary_light_color')}
                  />
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Secondary Color"
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: (
                        <Typography className={classes.tooltipText}>
                          {TooltipTitle.secondaryColour}
                        </Typography>
                      ),
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    {...this.makeFieldProps('secondary_color')}
                  />
                </Grid>
              </Grid>
              <StyledDivider extraStyles={classes.divider} />
              <Typography className={classes.sectionHeaders}>
                Basic Information
              </Typography>
              <Grid container>
                <Grid className={classes.formLeft} size={6}>
                  <WaveSelectField
                    label="Timezone"
                    menuItems={timezoneOptions}
                    {...this.makeFieldProps('timezone')}
                  />
                </Grid>
                <Grid className={classes.formRight} size={6}>
                  <WaveSelectField
                    label="Points Anniversary"
                    menuItems={SelectFieldOptions.pointsAnniversary}
                    {...this.makeFieldProps('points_anniversary_month')}
                  />
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="From Email Name"
                    {...this.makeFieldProps('from_email_name')}
                  />
                </Grid>
                <Grid size={6} className={classes.formRight}>
                  <WaveTextField
                    label="From Email Address"
                    readOnly={!user.is_super_admin}
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: <DefaultEmail />,
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    type="email"
                    {...this.makeFieldProps('from_email_address')}
                  />
                </Grid>
              </Grid>

              {user.is_super_admin ||
                instituteDetails.vcm_enabled ? (
                <>
                  <Grid container spacing={2}>
                    <Grid >
                      <Grid
                        container
                        direction={'row'}
                        alignItems="baseline"
                        spacing={1}
                      >
                        <Grid >
                          <Typography className={classes.slimHeader}>
                            VCM
                          </Typography>
                        </Grid>                       
                      </Grid>

                      {user.is_super_admin ? (
                        <Typography>
                          VCM is {instituteDetails.vcm_enabled ? 'enabled' : 'disabled'}.
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid size={12}>
                      <Typography className={classes.sectionHeaders}>
                        Course/UNIT Matrix
                      </Typography>

                      <Button
                        component={Link}
                        to={`/institutes/${instituteDetails.id}/manage_vcm_course_unit`}
                        color="secondary"
                        size="small"
                        variant="contained"
                      >
                        <Typography variant="button">
                          MANAGE COURSE/UNIT MATRIX
                        </Typography>
                      </Button>
                    </Grid>
                    <Grid size={12}>
                      <Typography className={classes.sectionHeaders}>
                        Professional Qualifications
                      </Typography>

                      <Button
                        component={Link}
                        to={`/institutes/${instituteDetails.id}/manage_vcm_professional_qualifications`}
                        color="secondary"
                        size="small"
                        variant="contained"
                      >
                        <Typography variant="button">
                          MANAGE PROFESSIONAL QUALIFICATIONS
                        </Typography>
                      </Button>
                    </Grid>
                  </Grid>
                  <StyledDivider extraStyles={classes.divider} />
                </>
              ) : null}
              <Typography className={classes.sectionHeaders}>
                Calendar Settings
              </Typography>
              <Grid container>
                <Grid size={6} className={classes.formLeft}>
                  <WaveSelectField
                    label="Calendar Attachment Type"
                    menuItems={icalTypeOptions}
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: (
                        <Typography className={classes.tooltipText}>
                          {TooltipTitle.icalType}
                        </Typography>
                      ),
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    {...this.makeFieldProps('ical_type')}
                  />
                </Grid>
                <Grid size={6} className={classes.formRight}>
                  <DefaultCheckbox
                    label="Enable Add All to Calendar"
                    checkboxValue={true}
                    unCheckValue={false}
                    tooltipProps={{
                      placement: 'right',
                      titleComponent: (
                        <Typography className={classes.tooltipText}>
                          {TooltipTitle.addAllToCalendarEnabled}
                        </Typography>
                      ),
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                    {...this.makeFieldProps('add_all_to_calendar_enabled')}
                  />
                </Grid>
              </Grid>
              <StyledDivider extraStyles={classes.divider} />
              <Typography className={classes.sectionHeaders}>
                Additional Reporting Requirements
              </Typography>
              <Grid container>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Requirement 1 Name"
                    {...this.makeFieldProps('requirement_1_name')}
                  />
                </Grid>
                <Grid size={3} className={classes.formRight}>
                  <DefaultCheckbox
                    label="Requirement 1 Enabled"
                    checkboxValue={true}
                    unCheckValue={false}
                    {...this.makeFieldProps('requirement_1_enabled')}
                  />
                </Grid>
                <Grid size={3} className={classes.formLeft}>
                  <DefaultCheckbox
                    label="Show on Overview Dash"
                    checkboxValue={true}
                    unCheckValue={false}
                    disabled={!instituteDetails.requirement_1_enabled}
                    {...this.makeFieldProps('requirement_1_on_dash')}
                  />
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Requirement 2 Name"
                    {...this.makeFieldProps('requirement_2_name')}
                  />
                </Grid>
                <Grid size={3} className={classes.formRight}>
                  <DefaultCheckbox
                    label="Requirement 2 Enabled"
                    checkboxValue={true}
                    unCheckValue={false}
                    {...this.makeFieldProps('requirement_2_enabled')}
                  />
                </Grid>
                <Grid size={3} className={classes.formLeft}>
                  <DefaultCheckbox
                    label="Show on Overview Dash"
                    checkboxValue={true}
                    unCheckValue={false}
                    disabled={!instituteDetails.requirement_2_enabled}
                    {...this.makeFieldProps('requirement_2_on_dash')}
                  />
                </Grid>
              </Grid>
              <StyledDivider extraStyles={classes.divider} />
              <Typography className={classes.sectionHeaders}>
                Custom User Fields
              </Typography>
              <Grid container>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Custom User Field 1 Name"
                    {...this.makeFieldProps('custom_user_field_1')}
                  />
                </Grid>
                <Grid size={3} className={classes.formRight}>
                  <DefaultCheckbox
                    label="Custom Field 1 Enabled"
                    checkboxValue={true}
                    unCheckValue={false}
                    {...this.makeFieldProps('custom_user_field_1_enabled')}
                  />
                </Grid>
                <Grid size={3} className={classes.formLeft}>
                  <DefaultCheckbox
                    label="Show for Program Registrations"
                    checkboxValue={true}
                    unCheckValue={false}
                    disabled={!instituteDetails.custom_user_field_1_enabled}
                    {...this.makeFieldProps('custom_user_field_1_on_registrations')}
                  />
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Custom User Field 2 Name"
                    {...this.makeFieldProps('custom_user_field_2')}
                  />
                </Grid>
                <Grid size={3} className={classes.formRight}>
                  <DefaultCheckbox
                    label="Custom Field 2 Enabled"
                    checkboxValue={true}
                    unCheckValue={false}
                    {...this.makeFieldProps('custom_user_field_2_enabled')}
                  />
                </Grid>
                <Grid size={3} className={classes.formLeft}>
                  <DefaultCheckbox
                    label="Show for Program Registrations"
                    checkboxValue={true}
                    unCheckValue={false}
                    disabled={!instituteDetails.custom_user_field_2_enabled}
                    {...this.makeFieldProps('custom_user_field_2_on_registrations')}
                  />
                </Grid>
              </Grid>
              <StyledDivider extraStyles={classes.divider} />
              <Typography className={classes.sectionHeaders}>
                Single Sign-on
              </Typography>
              <Grid container>
                <Grid className={classes.formLeft} size={12}>
                  <Typography>
                          SSO is {instituteDetails.sso_enabled ? 'enabled' : 'disabled'}.
                  </Typography>                 
                </Grid>
                <Grid size={6} className={classes.formLeft}>
                  <WaveTextField
                    label="Domain names"
                    {...this.makeFieldProps('sso_domain_names')}
                    tooltipProps={{
                      placement: 'top',
                      titleComponent: <SSODomainName />,
                      tooltipContainer: classes.tooltipContainer,
                      tooltipPopper: classes.popper
                    }}
                  />
                </Grid>
                <Grid size={6} className={classes.formRight}>
                  <WaveTextField
                    label="User Pool"
                    {...this.makeFieldProps('sso_user_pool')}
                  />
                </Grid>
              </Grid>
              {
                user.is_super_admin ?
                  <>
                    <StyledDivider extraStyles={classes.divider} />
                    <InstituteDeactivationSection
                      classes={classes}
                      onInstituteChange={onInstituteChange}
                      instituteDetails={instituteDetails}
                    />
                  </>
                  : null
              }
            </form>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(InstituteDetails, instituteDetailsStyles, {
  withTheme: true
});
